import Glide from '@glidejs/glide';
import { initWhenVisible } from '../_shared/lazy-init';

( () => {
	const BLOCK_CLASS = 'wp-block-phrase-com-suggested-reading';
	const blocks = document.querySelectorAll( `.${ BLOCK_CLASS }` );
	if ( ! blocks.length ) {
		return;
	}

	blocks.forEach( ( block ) => {
		if ( block.classList.contains( `${ BLOCK_CLASS }--grid` ) ) {
			return;
		}

		const slider = block.querySelector< HTMLDivElement >( `.${ BLOCK_CLASS }__slider` );
		if ( ! slider ) {
			return;
		}

		initWhenVisible( block, () => {
			const glide = new Glide( slider, {
				type: 'slider',
				gap: 0,
				perView: 3,
				keyboard: false,
				bound: true,
				rewind: false,
				breakpoints: {
					1024: {
						perView: 2,
					},
					600: {
						perView: 1,
					},
				},
			} );

			glide.mount();
		} );
	} );
} )();
